var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "custom-class": "invoice-email-window",
            "close-on-click-modal": false,
            visible: _vm.innerVisible,
            width: "480px",
            title: _vm.$t("CargoMsg.Cargo_SupplementaryInformation")
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            },
            close: function($event) {
              _vm.innerVisible = false
            }
          }
        },
        [
          _c(
            "el-form",
            { staticStyle: { padding: "5px" } },
            [
              _c(
                "el-form-item",
                [
                  _c("span", [
                    _vm._v(
                      "1." +
                        _vm._s(
                          _vm.$t(
                            "CargoMsg.Cargo_InvoiceTypeOfTheOppositePlatform"
                          )
                        )
                    )
                  ]),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "240px", "padding-left": "20px" },
                      attrs: { no: "1" },
                      model: {
                        value: _vm.invoiceType,
                        callback: function($$v) {
                          _vm.invoiceType = $$v
                        },
                        expression: "invoiceType"
                      }
                    },
                    _vm._l(_vm.invoiceTypeList, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item, value: item }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("el-form", { staticStyle: { padding: "5px" } }, [
            _c("span", [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.rowData.length === 0
                      ? "2." +
                          _vm.$t("Message.ContactAndEmailAreNotMaintained") +
                          ":"
                      : "2." +
                          _vm.$t(
                            "Message.PleaseSelectTheMaintainedContactAndMailbox"
                          ) +
                          ":"
                  )
              )
            ]),
            _c(
              "div",
              { staticClass: "app-main-inner-row" },
              [
                _c("cargo-ag-grid", {
                  style: { width: "380px", height: "150px" },
                  attrs: {
                    "show-side-bar": false,
                    "grid-options": _vm.gridOptions,
                    "column-defs": _vm.columnDefs,
                    "row-data": _vm.rowData
                  },
                  on: { gridReady: _vm.onGridReady }
                })
              ],
              1
            )
          ]),
          _c(
            "el-form",
            { staticStyle: { "padding-top": "50px" } },
            [
              _c("el-form-item", [
                _c("span", [
                  _vm._v(
                    "3." +
                      _vm._s(_vm.$t("Message.PleaseSupplementOtherMailboxes")) +
                      ":"
                  )
                ]),
                _c("span", [
                  _vm._v(
                    "(" +
                      _vm._s(
                        _vm.$t(
                          "Message.PleaseSeparateMultipleEmailAddressesWithCommas"
                        )
                      ) +
                      ")"
                  )
                ])
              ]),
              _c(
                "el-form-item",
                { staticClass: "el-form-item-textarea" },
                [
                  _c("el-input", {
                    attrs: { no: "2", type: "textarea" },
                    model: {
                      value: _vm.mailInputTextArea,
                      callback: function($$v) {
                        _vm.mailInputTextArea = $$v
                      },
                      expression: "mailInputTextArea"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
            _c(
              "span",
              [
                _c(
                  "el-button",
                  {
                    attrs: { no: "3", type: "primary" },
                    on: { click: _vm.sendButtonClick }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ConfirmR")))]
                ),
                _c(
                  "el-button",
                  { attrs: { no: "4" }, on: { click: _vm.closeHandler } },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }